/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const paths = {
  consent: 'consent',
  paymentMethods: 'paymentmethods',
  personalData: 'personal-data',
  linkedAccounts: 'linked-accounts',
  thirdPartyApps: 'third-party-apps',
  secondaryUser: 'secondary-user',
}
